import React, { useEffect, useState } from "react";
import { Button, Modal, Paper, Stack, Typography } from "@mui/material";
import { ColorsV2 } from "app/constants/color";
import { Buttons } from "app/constants/sizing";
import { MuiColorInput } from "mui-color-input";
import { useDispatch } from "react-redux";
import { updateUserSettings } from "app/store/features/userSettingsSlice";


const InfoObjectModal = ({open, onClose, t, color, id}) => {
    const [newColor, setNewColor] = useState(color);
    const dispatch = useDispatch();

    useEffect(() => {
        setNewColor(color);
    }, [color])

    const handleSave = () => {
        if(!id) return;
        dispatch(updateUserSettings({key: 'chartColors', value: {[id]: newColor}}))
        onClose();
    };
    
    return(
        <Modal
        open={open}
        onClose={onClose}
        sx={{
          // position: "absolute",
          // top: "50%",
          // left: "50%",
          // transform: "translate(-50%, -50%)",
          // width: 400,
          // bgcolor: "background.paper",
          // boxShadow: 24,
          // p: 4,
          // borderRadius: '4px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',

        }}>
        {newColor &&
            <Paper sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                backgroundColor: ColorsV2.secondary,
                padding: '20px',
            }}>
                <Typography sx={{color: ColorsV2.white}}>
                    {t('info_class_modal_title')}
                </Typography>
                <MuiColorInput
                value={newColor}
                onChange={(updatedColor) => setNewColor(updatedColor)}
                sx={{
                    background: ColorsV2.primary,
                    borderRadius: '4px',
                    '& input': {
                    color: ColorsV2.textInfo,
                    fontSize: '0.875rem'
                    }
                }}
                ></MuiColorInput>
                <Stack direction='row' alignItems='center' justifyContent='flex-end' gap={1}>
                    <Button onClick={onClose} sx={{
                    ...Buttons.baseStyle.primaryButtonLowPriority,
                    alignSelf: 'flex-end',
                    }}>
                    {t('info_class_modal_close')}
                    </Button>
                    <Button
                    onClick={handleSave}
                    disabled={newColor === color ? true : false}
                    sx={{
                    ...Buttons.baseStyle.primaryButtonHighPriority,
                    alignSelf: 'flex-end',
                    }}>
                    {t('info_class_modal_save')}
                    </Button>
                </Stack>
            </Paper> || <></>}
        </Modal>
    )
}

export default InfoObjectModal